import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const VerticalNavbar = ({ 
  menuItems = [
    { to: '/', icon: 'bi bi-house', text: 'Dashboard' },
    { to: '/plots', icon: 'bi bi-graph-up', text: 'Weather plots' },
    { to: '/realtime', icon: 'bi bi-speedometer', text: 'Realtime' },
    { to: '/forecast', icon: 'bi bi-cloud-sun', text: 'Forecasts' },
    { to: '/observability', icon: 'bi bi-eye-fill', text: 'Observability' },
    { to: '/webcams', icon: 'bi bi-webcam', text: 'Webcams' },
    /* { to: '/meteosat', icon: 'bi bi-webcam', text: 'Meteosat images' }, */
     { to: '/settings', icon: 'bi bi-gear', text: 'Settings' }, 
  ],
  onItemClick = null,
  backgroundColor = '#333',
  width = '250px'
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Cerrar con tecla Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  // Prevenir scroll del body cuando está abierto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Cleanup al desmontar
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const closeNavbar = () => {
    setIsOpen(false);
  };

  const handleItemClick = (item, e) => {
    if (onItemClick) {
      e.preventDefault();
      onItemClick(item);
    }
    closeNavbar();
  };

  return (
    <>
      {/* Botón hamburguesa */}
      <button
        className={`navbar-toggle ${isOpen ? 'open' : ''}`}
        onClick={toggleNavbar}
        aria-label="Toggle navigation menu"
      >
        <i className={`bi ${isOpen ? 'bi-x-lg' : 'bi bi-menu-button-wide'}`}></i>
      </button>

      {/* Overlay */}
      <div
        className={`navbar-overlay ${isOpen ? 'open' : ''}`}
        onClick={closeNavbar}
      ></div>

      {/* Navbar vertical */}
      <nav 
        className={`vertical-navbar ${isOpen ? 'open' : ''}`}
        style={{ 
          right: isOpen ? '0' : `-${width}`,
          width: width,
          background: backgroundColor 
        }}
      >
        <ul className="navbar-menu">
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.to}
                className={({ isActive }) => isActive ? 'active' : ''}
                onClick={(e) => handleItemClick(item, e)}
              >
                <i className={item.icon}></i>
                {item.text}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default VerticalNavbar;